import { lazy } from 'react';
import { PageNotFound } from '../components/core';
import MasterLayout from '../components/layout/MasterLayout';
import { routeImports } from './routePrefetch';

const Home = lazy(routeImports.home);
const TourDetails = lazy(routeImports.tourDetails);
const AboutUs = lazy(routeImports.aboutUs);
const ContactUs = lazy(routeImports.contactUs);
const Checkout = lazy(routeImports.checkout);
const MyProfile = lazy(routeImports.myProfile);
const MyBookings = lazy(routeImports.myBookings);
const MyWishlist = lazy(routeImports.myWishlist);
const Categories = lazy(routeImports.categories);
const TopPackages = lazy(routeImports.topPackages);
const Faq = lazy(routeImports.faq);
const EventDetails = lazy(routeImports.eventDetails);
const TermsConditon = lazy(routeImports.termsCondition);

export {
  MyProfile,
  MyWishlist,
  Home,
  TourDetails,
  PageNotFound,
  MasterLayout,
  AboutUs,
  ContactUs,
  Checkout,
  MyBookings,
  Categories,
  TopPackages,
  Faq,
  EventDetails,
  TermsConditon,
};
